import React from "react";
import { URLS } from "_configs/URLS";
import { Link, useHistory } from "react-router-dom";
import { PROPERTY_TABS } from "properties/propertyPage/PropertyContent";
import { appFiltersStore } from "appFiltersStore";
import { FILTERS_KEYS } from "_configs/filtersConfig";
import { TFilterType } from "admin/_common/resources/ResourceFilterMdl";
import { userStore } from "users/_stores/userStore";
import PropertyFavoriteCardContent from "properties/propertyCard/components/favorite/PropertyFavoriteCardContent";
import { FavoriteCardProps } from "properties/propertyCard/types/favorite-card.type";

type Props = {
    item: FavoriteCardProps;
    onRemoveFavorite?: () => void;
};

export const PropertyFavoriteCard = ({ item }: Props) => {
    const history = useHistory();
    const favoritesUnits = userStore.favoritesUnits.some((unit) => unit.propertyId === item._id);
    return (
        <div id={"favoriteCard"} key={item._id}>
            <Link
                to={URLS.property(item.urlAlias) + `?propertyTab=${PROPERTY_TABS.INVENTORY}`}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (favoritesUnits) {
                        appFiltersStore.updateFilters([
                            {
                                id: FILTERS_KEYS.FAVORITE_ITEMS,
                                type: TFilterType.NUMBER,
                                value: userStore.user?._id,
                            },
                        ]);
                    }
                    history.push(URLS.property(item.urlAlias) + `?propertyTab=${PROPERTY_TABS.INVENTORY}`);
                }}
            >
                <PropertyFavoriteCardContent item={item} />
            </Link>
        </div>
    );
};
